import MemberName from './MemberName';

export default MemberName;
